export default "<p>compra-cursos-compra-realizada works!</p>\r\n";